/* eslint-disable */
// <auto-generated>
// Generated by projects/template-ui/scripts/generate-contract-types.ts.
// Source: api/src/Riley.Jms.Application/Schemas/schema-manifest.json.
// </auto-generated>

export interface WorkflowHearingRescheduleRequest {
  expectedETag: string;
  expectedTargetETag: string;
  occurrenceId: number;
  reasonCode: string;
  scheduledEndUtc: string;
  scheduledProceedingId: number;
  scheduledStartUtc: string;
  targetProceedingId: number;
}

export const WorkflowHearingRescheduleRequestForm = {
  "contract": "WorkflowHearingRescheduleRequest",
  "version": 1,
  "fields": [
    {
      "name": "scheduledProceedingId",
      "type": "integer",
      "control": "number",
      "label": "Hearing record",
      "labelToken": "hearing.reschedule.record",
      "required": true,
      "nullable": false,
      "minimum": 1,
      "errorCodes": []
    },
    {
      "name": "scheduledStartUtc",
      "type": "string",
      "control": "date-time",
      "label": "New hearing start",
      "labelToken": "hearing.reschedule.start",
      "required": true,
      "nullable": false,
      "maxLength": 40,
      "dateSemantics": "utc-instant",
      "errorCodes": []
    },
    {
      "name": "scheduledEndUtc",
      "type": "string",
      "control": "date-time",
      "label": "New hearing end",
      "labelToken": "hearing.reschedule.end",
      "required": true,
      "nullable": false,
      "maxLength": 40,
      "dateSemantics": "utc-instant",
      "errorCodes": []
    },
    {
      "name": "reasonCode",
      "type": "string",
      "control": "text",
      "label": "Reason for rescheduling",
      "labelToken": "hearing.reschedule.reason",
      "required": true,
      "nullable": false,
      "minLength": 1,
      "maxLength": 120,
      "errorCodes": []
    }
  ]
} as const;
